module.exports = __webpack_public_path__ + "img/level_two.cd5b6959.png";